import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges, ElementRef, AfterViewInit, TemplateRef } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';

import { CommonTableService } from './../../services/common-table.service';

import { CommonTablePagingComponent } from './common-table-paging/common-table-paging.component';
// import { DatatableComponent } from '@swimlane/ngx-datatable';

export interface TableContextmenuData {
	event: MouseEvent;
	content: any;
	type: 'body' | 'header';
}
export interface SortObject {
	dir: 'asc' | 'desc';
	prop: string;
}

@Component({
	selector: 'app-common-datagrid',
	templateUrl: './common-datagrid.component.html',
	styleUrls: ['./common-datagrid.component.css']
})
export class CommonDatagridComponent implements OnInit, OnChanges, AfterViewInit {

	// INPUT EITHER: Rows & columns // TODO: ??? make rows & columns higher priority than rawData
	@Input() rows: any[];
	@Input() columns: any[];
	// OR: Raw data from which columns and rows will be extracted
	@Input() rawData: any[];

	// Selected rows. In single select: [row]
	@Input() selectedRows: any[] = [];
	@Input() selectionType = 'single'; // vs. 'multiClick'

	// Paging params
	// Paging footer or normal footer
	@Input() isPaging?: boolean;
	@Input() totalNum: number;
	@Input() pageSize: number;
	@Input() hidePaging: boolean;

	@Input() columnMode? = 'standard';
	@Input() headerH?: number;
	// @Input() footerH?: number;
	@Input() rowH?: number;
	@Input() messages?: object;
	// Default to have vertical scroll bar
	@Input() isScrollbarV? = true;
	// Default to have horizontal scroll bar
	@Input() isScrollbarH? = true;
	//
	@Input() rowClass: (row) => any;
	// Optional. check the row can be selected or not
	@Input() selectCheck;
	//
	@Input() sorts: SortObject[];
	@Input() sortType: 'single' | 'multi';

	@Input() sampleData: boolean;

	@Input() isPagingOnTop: boolean;

	@Output() select: EventEmitter<any> = new EventEmitter();
	@Output() sort: EventEmitter<any> = new EventEmitter();
	@Output() scroll: EventEmitter<any> = new EventEmitter();
	@Output() activate: EventEmitter<any> = new EventEmitter();
	@Output() paging: EventEmitter<any> = new EventEmitter();
	@Output() tableContextmenu: EventEmitter<TableContextmenuData> = new EventEmitter();

	upperTempl: TemplateRef<any>;
	lowerTempl: TemplateRef<any>;
	@ViewChild('TableTempl', { static: false }) tableTempl: TemplateRef<any>;
	@ViewChild('PagingTempl', { static: false }) pagingTempl: TemplateRef<any>;

	@ViewChild('tablePaging', { static: false }) tablePaging: CommonTablePagingComponent;
	@ViewChild('table', { static: false }) table: DatatableComponent;

	constructor(
		private elemRef: ElementRef,
		private tableService: CommonTableService
	) { }

	clearTableData() {
		this.columns = [];
		this.rows = [];
		this.selectedRows = [];
	}
	// Set page number without calling onPaging
	reset(pageNum, totalNum) {
		if (this.tablePaging) {
			this.tablePaging.reset(pageNum, totalNum);
		}
	}
	resize() {
		this.table.recalculate();
	}
	onSelectRows(event) {
		this.select.emit(event);
	}
	onSort(event) {
		this.sort.emit(event);
	}
	onScroll(event) {
		const offsetY = event.offsetY;
		// total height of all rows in the viewport
		const tableElem = this.elemRef.nativeElement.querySelector('ngx-datatable');
		const viewHeight = tableElem.getBoundingClientRect().height - this.table.headerHeight;
		// check if we scrolled to the end of the viewport
		const isPageEnd = offsetY + viewHeight >= this.rows.length * this.table.rowHeight;
		this.scroll.emit({
			e: event,
			isPageEnd: isPageEnd
		});
	}
	onActivate(event) {
		this.activate.emit(event);
	}
	onPaging(event) {
		this.paging.emit(event);
	}
	onContextmenu(e) {
		this.tableContextmenu.emit(e);
	}
	// On rawData change
	onRawDataChange(rawData) {
		if (!rawData) {
			this.clearTableData();
			return;
		}
		this.convertRawDataToTableData(rawData);
	}
	convertRawDataToTableData(rawData) {
		this.columns = this.tableService.setColumnsFromRows(rawData);
		this.rows = rawData;
	}
	// Display the selected row in the view by changing the scrollTop
	public scrollRowIntoView(rowIdx: number, totalRowCount: number) {
		if (rowIdx < 0 || totalRowCount === 0) { return; }
		// Table body
		const tableBodyElem = this.elemRef.nativeElement.querySelector('datatable-body');
		// Row height
		const firstRowElem = this.elemRef.nativeElement.querySelector('datatable-body-row');
		if (tableBodyElem && firstRowElem) {
			// Row height
			const rh = firstRowElem.clientHeight;
			// The distance between element top to table body top
			const elemTop = rh * rowIdx;
			// The distabce of the place to display row: middle of the table body view
			const displayPosition = tableBodyElem.clientHeight / 2;

			let scrollTop = elemTop - displayPosition;
			if (scrollTop < 0) {
				scrollTop = 0;
			}
			// Check if it's already in view
			if (tableBodyElem.scrollTop < (rowIdx * rh - rh) && tableBodyElem.scrollTop > (rowIdx * rh - tableBodyElem.clientHeight + rh)) {
				return;
			}
			// Scroll
			tableBodyElem.scrollTop = scrollTop;
		}
	}

	ngOnInit() {
		this.rowH = this.rowH ? this.rowH : this.tableService.defaultTableConfig.rowH;
		this.headerH = this.headerH ? this.headerH : this.tableService.defaultTableConfig.headerH;
		// this.footerH = (this.footerH || this.footerH === 0) ? this.footerH : this.tableService.defaultTableConfig.footerH;
		this.messages = this.messages ? this.messages : this.tableService.defaultTableConfig.messages;
	}
	ngAfterViewInit() {
		if (this.isPagingOnTop) {
			this.upperTempl = this.pagingTempl;
			this.lowerTempl = this.tableTempl;
			// // Swap position
			// const tableElem = this.elemRef.nativeElement.querySelector('ngx-datatable');
			// const tablePagingElem = this.elemRef.nativeElement.querySelector('app-common-table-paging');
			// if (tableElem && tablePagingElem) {
			// 	tableElem.parentNode.insertBefore(tablePagingElem, tableElem);
			// }
		} else {
			this.upperTempl = this.tableTempl;
			this.lowerTempl = this.pagingTempl;
		}
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.rawData && !changes.rawData.firstChange) {
			this.onRawDataChange(changes.rawData.currentValue);
		}
	}
}
